import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";

import Banner from "../../assets/homeImage/banner.png";

import GradientTextWithStroke from "./index";
import React from "react";

const Privacy = () => {
  const tableData = [
    {
      level: "Level 1",
      channel: "In-Platform Automated Support",
      description:
        "User-friendly automated system for immediate transaction-related queries. We aim to resolve within 24-48 hours.",
    },
    {
      level: "Level 2",
      channel: "Customer Support Team",
      description:
        "Option to speak with a dedicated Customer Support Team via the Digital Venue if Level 1 is unsatisfactory. Resolution attempt within 24-48 hours.",
    },
    {
      level: "Level 3",
      channel: "Grievance Redressal Officer",
      description:
        "For unresolved complaints or grievances pertaining to Terms violations, objectionable content, or access issues.",
    },
  ];

  const tableData1 = [
    {
      category: "Financial Management",
      practice:
        "Only commit funds to your Winnsta Wallet that are within your disposable income. Never use money required for essential expenses such as housing, food, education, or bills. Do not borrow funds to support your activities on the Digital Venue. Avoid deploying all available funds in a single game or session.",
    },
    {
      category: "Time Management",
      practice:
        "Pre-determine your play sessions and the amount of time you spend on the Digital Venue, and stick to this plan. Take regular breaks and time-outs. Ensure your gameplay duration is balanced with other life activities, work, and social engagements.",
    },
    {
      category: "Emotional State",
      practice:
        "Refrain from engaging with the games when you are feeling stressed, depressed, angry, or overly tired. A clear mind is essential for making sound decisions.",
    },
    {
      category: "Priorities",
      practice:
        "Always complete your personal and professional obligations before starting a game session. Gameplay should never take precedence over important tasks.",
    },
    {
      category: "Competency",
      practice:
        "Participate in games that align with your skill level and financial capacity. Resist the urge to enter high-stakes environments, even after a consistent run of successful outcomes.",
    },
  ];

  return (
    <Box backgroundColor={"#3A005E"}>
      <Box
        bgImage={`url(${Banner})`}
        bgSize="cover"
        bgPosition="center"
        w="100%"
        h={{ base: "300px", md: "469px" }}
        px={{ base: 4, md: 20 }}
        py={{ base: 8, md: 12 }}
        color="white"
      >
        <Flex direction="column" justify="center" align="center" h="100%">
          <Box
            textAlign={{ base: "center", md: "right" }}
            ml={{ base: 0, md: "50%" }} // <- sets content to start at 50% width on md screens
          >
            <GradientTextWithStroke
              text="Anti-Money Laundering Policy"
              desktopFontSize={45}
              mobileFontSize={25}
              strokeColor="#5c2d06"
              strokeWidth={5}
              gradientStops={[
                { offset: "25%", color: "#FAECA4" },
                { offset: "100%", color: "#B5763A" },
              ]}
            />
            <Text
              fontSize={{ base: "16px", md: "25px" }}
              fontStyle="italic"
              fontWeight="500"
              letterSpacing="0.2em"
              mr="280px"
            >
              {/* Winnsta - GAMES */}
            </Text>
          </Box>
        </Flex>
      </Box>

      {/* Section 3: Text */}
      <Box maxW="100%" py={6} px={4}>
        <Text textAlign="center" fontSize="35px" color="white" mb={6}>
          Winnsta Gaming - Anti-Money Laundering Policy
        </Text>

        <Flex
          width="100%"
          justifyContent="center"
          alignItems="center"
          color="#A1A1A1"
        >
          <Flex
            width={{ base: "90%", md: "80%" }}
            justifyContent="start"
            alignItems="start"
            flexDir={"column"}
          >
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              1. Our Commitment
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              <b>Winnsta Gaming ("Company," "We," "Us")</b>, operating the digital
              venue at <b> winnstagaming.com </b> and its associated applications, is
              committed to operating with the highest ethical and business
              standards. This includes strict adherence to all applicable laws
              and regulations designed to <b>combat money laundering</b> (AML) and
              other illegal financial activities.<br></br>
              <br></br>
              As a core part of our business operations, the Company has
              implemented robust compliance measures, appropriate for our
              <b> Offerings</b> and the <b>Digital Venue</b>, to deter and detect potential
              illicit activity. These measures encompass customer screening,
              identification protocols, and rigorous transaction controls.
              <br></br>
              <br></br>
              This <b>Anti-Money Laundering Policy (AML Policy)</b> details the
              measures taken to detect and deter illicit activity on our <b> Digital
              Venue</b>. It must be read in conjunction with our <b>Terms and
              Conditions</b> and <b>Privacy Policy</b> and is binding on all <b>Users</b>.
              <br></br>
              <br></br>
              Capitalized terms used herein, if not defined, carry the same
              meaning as provided in our Terms and Conditions.<br></br>
              <br></br>
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              2. User Identification Protocol
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              The Company takes all reasonable steps to confirm the identity of
              any individual utilizing our Offerings.
            </Text>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              2.1 Initial Verification
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              We collect minimum identification details from every User who
              registers an account, as stipulated in our Terms and Privacy
              Policy.
            </Text>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              2.2 Withdrawal 
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Registered Users wishing to <b>withdraw funds</b> from their account may
              be required to have their account officially confirmed by the
              Company. For this purpose, the Company may mandate the submission
              of:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Valid Photo Identification</b> and <b>Address Proof</b> documents (for
                  proof of identity and address).
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>PAN (Permanent Account Number)</b> verification, <b>Aadhaar </b>
                  verification, and confirmation of withdrawal bank details
                  aligned with verified documents.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                 <b>  Geolocation verification.</b> 
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Failure to provide satisfactory identification documents or a
              valid bank account may result in the <b> forfeiture of amounts </b> 
              requested for withdrawal.
            </Text>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              2.3 Enhanced Due Diligence
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              The Company reserves the right to request <b> additional information
              and documents</b>  from Users, beyond the initial requirements, to
              conduct thorough <b> Know Your Customer (KYC)</b> verification, enhance
              security, ensure compliance with evolving laws, or improve
              customer service. This may include government-authorised
              identification cards and further address proofs.
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              3. User Obligations
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              By using our Offerings, Users explicitly agree to comply with this
              AML Policy. Users confirm that they are <b>not using or intending to
              use</b> the Digital Venue or our Offerings to commit any criminal or
              listed offenses.
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Users are obligated to ensure that all personal information
              submitted during registration, verification, and ongoing use is
             <b> accurate, up-to-date, and belongs exclusively to them</b>.
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              4. Transaction Monitoring and Controls
            </Text>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              4.1 Monitoring Activity
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              We monitor all activity on the Digital Venue on an ongoing basis
              using both <b>manual and automated systems</b>. This monitoring utilizes
              rule-based systems to analyze User history and activity patterns,
              check for unusual behavior, and apply necessary controls or
              limits.
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Users must note that payments for Offerings and withdrawals are
              <b>only accepted through integrated electronic payment gateways. We
              do not accept or disburse payments in cash</b>.
            </Text>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              4.2 Handling Suspicious Behavior
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              If the Company detects activity considered <b>unusual or suspicious</b>,
              we may take any action deemed appropriate, including:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Requesting <b>additional information and/or documents</b> from the
                  User.
                </Text>
              </ListItem>
              {/* <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Mandating enhanced KYC verification.
                </Text>
              </ListItem> */}
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Restricting, suspending, or permanently terminating a User’s
                  account.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Disallowing or <b>forfeiting</b> the withdrawal of funds.
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              4.3 Suspicious Transaction Reporting
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              We align our monitoring with best industry practices and
              international guidelines. The intensity of monitoring may vary
              based on a User’s <b>risk profile, transaction volume, value,
              frequency</b>, and relationship patterns with other players.
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Any User account involved in suspicious transactions potentially
              related to money laundering or other offenses may be <b>reported to
              the appropriate law enforcement agencies</b>. For clarity, suspicious
              transactions include, but are not limited to:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Unusually complex transactions.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Transactions lacking a clear economic basis or apparent good
                  faith.
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Transactions appearing to involve proceeds from offenses
                  listed under applicable money laundering legislation (e.g.,
                  the Prevention of Money Laundering Act, 2002).
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              4.4 Record Keeping
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              We maintain meticulous records of all transactions occurring on
              our Digital Venue for the duration required under applicable laws
              and regulations. We may contact you periodically to ensure
              compliance with this policy.
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              5. Amendments to the AML Policy
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              The Company may <b>revise this AML Policy</b> at any time without prior
              individual notice. We will, however, ensure Users are periodically
              informed of this Policy and any changes, as required by law.
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Any updates to this AML Policy will be published and made
              accessible on the official Winnsta Gaming website,
              <b>winnstagaming.com</b>.
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Privacy;
